import { contractProductReady } from 'helpers/contract/contractProductReady';
import { Alert, Button, Loading } from 'modules';
import React, { useContext, useState } from 'react';
import moment from 'moment';
import { useMutation } from '@apollo/react-hooks';
import {
  SaveContractOnlineFormDataMutation,
  UpdateCacheContractOnlineFormMutation,
} from 'queries/ContractOnlineForms/ContractOnlineFormData';
import { notifyFailed } from 'helpers/notify';
import { WebsocketActions, WebsocketContext } from 'services/WebsocketContext';
import { FormScene } from 'constants/FormScene';
import { useSelector } from 'react-redux';
import {
  selectClientLogged,
  selectMeetingModeOnline,
  selectOnlineForm,
  selectOnlineFormContract,
} from 'stores/onlineForm/onlineForm';

interface ButtonTransmitReportProps {
  loading?: boolean;
}

const ButtonTransmitReport = ({ loading }: ButtonTransmitReportProps) => {
  const wsContext = useContext(WebsocketContext);

  const form = useSelector(selectOnlineForm);
  const contract = useSelector(selectOnlineFormContract);
  const isOnlineMode = useSelector(selectMeetingModeOnline);
  const isClientLogged = useSelector(selectClientLogged);

  const [submitting, setSubmitting] = useState<boolean>(false);
  const [updateCacheOnlineForm] = useMutation(UpdateCacheContractOnlineFormMutation);
  const [saveOnlineFormData] = useMutation(SaveContractOnlineFormDataMutation);

  const onClick = async () => {
    if (form) {
      try {
        setSubmitting(true);
        // todo: toto musí být jeden call
        await updateCacheOnlineForm({
          variables: {
            formId: form.form_id,
            data: {
              status: 'formSummaryLeave',
              transmitReportDone: moment().format(),
            },
          },
        });
        // uložím formulář
        await saveOnlineFormData({
          variables: {
            id: form?.id,
            data: {
              status: 'formSummaryLeave',
              transmitReportDone: moment().format(),
            },
          },
        });
        // přesun do kroku na předání posudku
        wsContext.send({
          action: WebsocketActions.STEP_CHANGE,
          value: FormScene.TransmitReport,
        });
      } catch (error) {
        notifyFailed('Pri odosielaní požiadavke na odovzdanie návrhu došlo k chybe');
      }
    }
  };

  const checkIsClientLogged = !isClientLogged && isOnlineMode;
  const isSigned = form && form.signIn !== null;

  if (!contract) {
    return null;
  }

  return (
    <>
      {loading === true && <Loading />}
      {(!contractProductReady(contract) || checkIsClientLogged) && (
        <Alert type="danger" canClose={false} className="text-left">
          {!contractProductReady(contract) && (
            <span>
              Posudok nie je možné odovzdať, zmluva nie je v stave 2 a), 2 b), 2 c) alebo 48 a), 48 b), 48 c)
              <br />
            </span>
          )}
          {checkIsClientLogged && <span>Posudok je možné odovzdať len ak je klient prihlásený</span>}
        </Alert>
      )}
      <Button
        variant="danger"
        size="sm"
        className="ml-1"
        loading={submitting}
        disabled={!contractProductReady(contract) || checkIsClientLogged || !isSigned || submitting}
        onClick={onClick}
      >
        Odovzdať posudok Oddlženie BONATO
      </Button>
    </>
  );
};

export default ButtonTransmitReport;
